import { AlpineComponent } from 'alpinejs';

type IconTeasersData = {}

export default ():AlpineComponent<IconTeasersData> => ({
  init() {
    this.$lazyLoad.update();

    // Big teaser
    const browserWidth = document.body.offsetWidth;
    const teasers = document.querySelectorAll(".ce-icon-teasers--big");
    if (teasers) {
      let maxHeight = 0;
      let heights: number[] = [];
      teasers.forEach(function(teaser) {
        if (browserWidth >= 768) {
          const items = teaser.querySelectorAll(".ce-icon-teasers-item");
          if (items) {
            items.forEach(function(item: Element) {
              const itemHeight = (item as HTMLElement).offsetHeight;
              heights.push(itemHeight);
            })
          }

          maxHeight = Math.max(...heights);
          if (items) {
            items.forEach(function(item: Element) {
              (item as HTMLElement).style.height = maxHeight + "px";
            })
          }
        } else {
          const items = teaser.querySelectorAll(".ce-icon-teasers-item");
          if (items) {
            items.forEach(function(item: Element) {
              (item as HTMLElement).style.height = "";
            })
          }
        }
      })
    }
    if (browserWidth >= 992) {
      const teasers = document.querySelectorAll(".ce-icon-teasers--big");
      const itemPadding = 32;
      if (teasers) {
        teasers.forEach(function(teaser: Element) {
          const teaserItem = teaser.querySelector(".ce-icon-teasers-item");
          if (teaserItem) {
            const itemWidth = (teaserItem as HTMLElement).offsetWidth;
            const itemHoverWidth = itemWidth * 2 + itemPadding;

            const hoverItems = teaser.querySelectorAll(".ce-icon-teasers-item--hover");
            if (hoverItems) {
              hoverItems.forEach(function(item: Element) {
                (item as HTMLElement).style.width = itemHoverWidth + "px";
              })
            }
          }
        })
      }
    }
  },
});
